import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { STORAGE } from '../../constants';
import { LocalStorageService } from '../../services/local-storage.service';
import Header from '../../components/layout/header.component';
import Asaid from '../../components/layout/asaid.component';
import Footer from '../../components/layout/footer.component';
import useBgPages from '../../hooks/use-bg-pages.hook';
import Icon from '../../components/forms/icon.component';
import moment from 'moment';
import UpdatePassword from './partial/update-password.partial';
import PrincipalCard from '../../components/cards/principal-card.component';

interface InfoCardItemProps {
  icon: string;
  title: string;
  value: string | any;
}

function ProfileSettings() {
  useBgPages();
  const { t } = useTranslation();
  const tabProfile = [{ key: 'tabOne', label: 'Actualizar contraseña' }];
  const session = LocalStorageService.get(STORAGE.SESSION);
  const [tab, setTab] = useState('tabOne');

  const InfoCardItem: React.FC<InfoCardItemProps> = ({ icon, title, value }) => (
    <div className="d-flex flex-stack mb-2 px-3 py-2 ms-n3">
      <div className="d-flex align-items-center">
        <Icon
          icon={icon}
          size="fs-2x"
          className="fw-bolder w-35px me-6 hover-scale"
          type="primary"
        />
        <div className="pe-2">
          <a title="resume" className="fs-5 text-gray-800 text-hover-info fw-bolder">
            {title}
          </a>
          <div className="text-muted fw-bolder mt-1 fw-bold">{value || t('general.no-info')}</div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="page d-flex flex-row flex-column-fluid">
        <Asaid />
        <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
          <Header />
          <div className="content fs-6 d-flex flex-column flex-column-fluid" id="kt_content">
            <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
              <div className="container-xxl">
                <PrincipalCard
                  btnBack
                  title={'Mi'}
                  titleBolder="perfil"
                  subtitle={`Configura los datos necesarios de tu perfil.`}
                  breadcrumbItems={['Configuración']}
                  tabs={tabProfile}
                  onTabChange={setTab}
                  onClick={() => {}}
                />
                <div className="d-flex flex-column flex-xl-row">
                  <div className="flex-column flex-lg-row-auto w-100 w-xl-350px mb-10">
                    <div className="card mb-5 mb-xxl-8 ">
                      <div className="card-body pt-15 mb-20">
                        <div className="d-flex flex-center flex-column mb-5">
                          <div className="symbol symbol-150px symbol-circle mb-7">
                            <img alt="profile-picture" src="/assets/media/avatars/av1.png" />
                          </div>
                          <a
                            className="fs-3 text-gray-800 text-hover-primary fw-bold mb-1"
                            href="#"
                          >
                            {session.full_name || t('general.no-info')}
                          </a>
                          <a
                            className="fs-5 fw-semibold text-muted text-hover-primary mb-6"
                            href="#"
                          >
                            {session.email}
                          </a>
                        </div>
                        <div className="d-flex flex-stack fs-4 py-3">
                          <div className="fw-bold">{t('profile-settings.infoCardTitle')}</div>
                        </div>
                        <div className="separator separator-dashed my-3" />
                        <div className="pb-5 fs-6">
                          <InfoCardItem
                            icon="bi-envelope-fill"
                            title={t('profile-settings.infoItem-1')}
                            value={session.email}
                          />
                          <InfoCardItem
                            icon="ki-faceid"
                            title={t('profile-settings.infoItem-2')}
                            value={session.profile}
                          />
                          <InfoCardItem
                            icon="ki-key"
                            title={t('profile-settings.infoItem-3')}
                            value={session.username}
                          />
                          <InfoCardItem
                            icon="ki-calendar-add"
                            title={t('profile-settings.infoItem-4')}
                            value={
                              session.created_at
                                ? moment(session.created_at).format('DD-MM-YYYY hh:mm:ss a')
                                : null
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-lg-row-fluid ms-lg-15">
                    <div className="card mb-xxl-8">
                      <div className="card-header align-items-center">
                        {tab === 'tabOne' && (
                          <h3 className="card-title align-items-start flex-column">
                            <span className="fw-bolder fw-bold fs-2">Actualizar contraseña</span>
                            <span className="text-gray-400 mt-2 fw-semibold fs-6"></span>
                          </h3>
                        )}
                      </div>
                      <div className="card-body">{tab === 'tabOne' && <UpdatePassword />}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default ProfileSettings;
